export default {
    text_1: "Notifikace",
    text_2: "Notifikace",
    text_3: "Nastav si, kdy ti můžeme poslat e-mail.",
    text_4: "E-mailové notifikace",
    text_5: "Upozornit e-mailem po otevření nabídky klientem",
    text_6: "Když si poprvé někdo otevře tvoji nabídku ONLINE, pošleme ti o tom e-mail. Pokud nechceš, aby to sledovalo tebe, nastav si svoji IP adresu v nastavení účtu.",
    text_7: "Uložit",
    text_8: "SuperFaktura",
    text_9: "Integrace třetích stran",
    text_10: "Integruj DOFFERO s jinými službami.",
    text_11: "Super Faktura",
    text_12: "Ve svém účtu v SuperFaktura v sekci Nástroje najdeš sekci API, kde je potřeba zkopírovat API klíč. Po propojení s DOFFERO bude možné jednoduše kopírovat cenové nabídky z DOFFERO do SuperFaktura a vytvořit z nich fakturu. Pro správné fungování doporučujeme vyplnit firemní údaje v",
    text_13: "nastavení firmy",
    text_14: "Přihlašovací e-mail do SuperFaktura",
    text_15: "API klíč",
}
